<template>
  <list-view-cell :context-menu-items="contextMenuItems">
    <template v-if="isPartnerOrVendor(contact.type)">
      <h3 class="text-sm font-bold pb-3">{{ contact.companyName }}</h3>
      <p class="text-sm pb-4">{{ contact.name }}</p>
    </template>
    <template v-else>
      <h3 class="font-bold">{{ contact.name }}</h3>
      <p class="text-sm pb-4" v-if="contact.companyName">
        {{ contact.companyName }}
      </p>
    </template>
    <template #bottom>
      <div class="px-4 pb-6">
        <div
          class="address pb-3"
          v-for="(place, index) in contact.places"
          :key="place.address_1"
        >
          <p
            class="text-xs uppercase"
            v-if="contact.places.length > 1 && index === 0"
          >
            PRIMARY
          </p>
          <p class="text-sm">{{ place.address_1 }}</p>
          <p class="text-sm" v-if="place.address_2">{{ place.address_2 }}</p>
          <p class="text-sm">
            {{ place.cityStateZip }}
            <a
              class="ml-1 text-red hover-bold"
              :href="generateGoogleMapsUrl(place)"
            >
              <i class="fal fa-map-marker-alt"></i>
            </a>
          </p>
        </div>

        <p class="text-sm pb-3" v-if="contact.email">{{ contact.email }}</p>
        <p class="text-sm" v-if="contact.phone">{{ contact.phone }}</p>
      </div>
    </template>
  </list-view-cell>
</template>

<script>
import { Contact } from "../../../models/Contact";
import { ContactTypes } from "../../../constants/contact-enums";
import ListViewCell from "./ListViewCell";
import { ContextMenuItem } from "../../../helper-classes/ContextMenuItem";
import ContactForm from "../../../forms/ContactForm";
import GenericDeleteModal from "../../../components/modals/GenericDeleteModal";

export default {
  name: "ContactCell",
  components: { ListViewCell },
  props: {
    contact: { type: Contact, required: true }
  },
  data() {
    return {
      contextMenuItems: [
        new ContextMenuItem("edit", () => {
          this.$store.commit("setCreateEditComponentParams", {
            createEditComponent: ContactForm,
            createEditComponentData: this.contact,
            createEditComponentIsShown: true
          });
        }),
        new ContextMenuItem("delete", () => {
          this.$store.commit("setConfirmationModalParams", {
            type: "delete",
            headerText: "Delete Confirmation",
            bodyComponent: GenericDeleteModal,
            bodyComponentData: {
              entityName: "contact",
              deleteFunction: () =>
                this.$store.dispatch("deleteContact", this.contact)
            },
            isShown: true
          });
        })
      ]
    };
  },
  methods: {
    isPartnerOrVendor(type) {
      return type === ContactTypes.PARTNER || type === ContactTypes.VENDOR;
    }
  }
};
</script>

<style scoped></style>
